import { Dialog, DialogContent, DialogActions, Button } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { useSnackbar } from "notistack";

import { DealerPostDto } from "../../../dtos/dealer";
import { AjaxResult } from "../../../enums/ajaxResult";
import { FormSection } from "../../shared/formSection";
import { FormField } from "../../shared/formField";
import { TextField } from "../../shared/TextField";
import { useApi } from "../../useApi";

interface Props {
    onClose: () => void;
    onLoadDealers: () => void;
}

export const AddDealerDialog = ({ onClose, onLoadDealers }: Props) => {
    const { dealerApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [newDealer, setNewDealer] = useState<DealerPostDto>({
        name: "",
    });
    const [loading, setLoading] = useState(false);

    const handleChangeName = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        e.persist();
        setNewDealer(prev => ({ ...prev, name: e.target.value }));
    }, []);

    const handleSave = useCallback(() => {
        setLoading(true);
        dealerApi.createDealer(newDealer).then(r => {
            if (r.result === AjaxResult.Success) {
                enqueueSnackbar(
                    `Successfully created new dealer: "${newDealer.name}"`,
                    { variant: "success" },
                );
                onLoadDealers();
                onClose();
            } else {
                enqueueSnackbar(
                    `Failed to create new dealer: "${newDealer.name}"`,
                    { variant: "error" },
                );
            }
            setLoading(false);
        });
    }, [dealerApi, newDealer, enqueueSnackbar, onLoadDealers, onClose]);

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="sm"
        >
            <DialogContent>
                <FormSection headerText="Create New Dealer">
                    <FormField label="Dealer Name" required>
                        <TextField
                            placeholder="Dealer Name"
                            value={newDealer.name}
                            onChange={handleChangeName}
                            variant="outlined"
                            stylesProps={{ width: 300 }}
                        />
                    </FormField>
                </FormSection>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={loading || newDealer.name === ""}
                >
                    {loading ? "Creating..." : "Create"}
                </Button>

                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
